import { axiosClient } from "services/axios";

import { TSettings } from "../../../types/settings";

function getSettingsRequest() {
  return axiosClient
    .get("settings")
    .then((res) => res.data as TSettings)
    .catch((e) => {
      console.warn(e);
    });
}

export { getSettingsRequest };
